module.exports = __webpack_public_path__ + "08e67d76fa9fb2afa73928c1d4d41f5c.gif";